import React from "react";
import { motion } from "framer-motion";
import { ShieldCheck, Flame, Building2, MapPin, FileCheck2, Clock } from "lucide-react";
import { WHY_US } from "@/lib/constants";

const ICONS = [ShieldCheck, Flame, Building2, MapPin, FileCheck2, Clock];

export const WhyUs = () => {
  return (
    <section id="why-us" className="relative py-24 sm:py-32 bg-[#142238] border-y border-slate-900" data-testid="why-us-section">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="max-w-3xl mb-16">
          <div className="flex items-center gap-3 mb-4">
            <span className="h-px w-10 bg-[#1E88E5]" />
            <span className="font-heading text-xs font-bold tracking-[0.3em] uppercase text-[#1E88E5]">
              Why customers stay
            </span>
          </div>
          <h2 className="font-heading text-4xl sm:text-6xl font-black uppercase tracking-tight text-white">
            Blue-collar craft. <br />
            <span className="text-[#E6B445]">White-glove finish.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-slate-900 border border-slate-900">
          {WHY_US.map((w, i) => {
            const Icon = ICONS[i] || ShieldCheck;
            return (
              <motion.div
                key={w.title}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.05 }}
                data-testid={`why-us-item-${i}`}
                className="bg-[#0B1726] p-10 hover:bg-[#142238] transition-colors group"
              >
                <Icon className="w-8 h-8 text-[#1E88E5] mb-6" strokeWidth={1.5} />
                <h3 className="font-heading text-2xl font-bold uppercase tracking-tight text-white mb-3">
                  {w.title}
                </h3>
                <p className="text-slate-400 leading-relaxed">{w.body}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
